import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { RootState } from "store/store";
import { decode } from "utils/HelperFunctions";
import {
  canViewCustomerPortalDocuments,
  isDocumentsPermissionPending,
} from "utils/customerPortalPermissions";
import { INVALID_PATH, invalidRouteState } from "utils/invalidRoute";

const DocumentsPermissionRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { clusterId: encodedClusterId } = useParams();
  const currentClusterId = decode(encodedClusterId || "", true);
  const {
    accountPermission,
    accountPermissionStatus,
    accountPermissionClusterId,
  } = useAppSelector((state: RootState) => state.auth);
  const permissionContext = {
    accountPermission,
    accountPermissionStatus,
    accountPermissionClusterId,
    currentClusterId,
  };

  if (isDocumentsPermissionPending(permissionContext)) {
    return (
      <div
        className="flex h-full w-full items-center justify-center text-txtSecondary"
        role="status"
        aria-live="polite"
      >
        Checking document access…
      </div>
    );
  }

  if (!canViewCustomerPortalDocuments(permissionContext)) {
    return (
      <Navigate
        to={encodedClusterId ? `/${encodedClusterId}/dashboard` : INVALID_PATH}
        replace={true}
        state={encodedClusterId ? undefined : invalidRouteState("not-found")}
      />
    );
  }

  return <>{children}</>;
};

export default DocumentsPermissionRoute;
